export const NAVBAR_MENU_DROPDOWN_CARD_DEFAULTS = {
  padding: '24px',
  width: 'fit-content',
  overflow: 'hidden',
  borderRadius: '16px',
  background: '#ffffff',
};

export const NAVBAR_MENU_DROPDOWN_FULL_DEFAULTS = {
  padding: '48px',
  width: '100vw',
  overflow: 'hidden',
  borderRadius: '0px',
  background: '#ffffff',
};

export const NAVBAR_MENU_DROPDOWN_MOBILE_DEFAULTS = {
  background: '#ffffff',
  padding: '8px 0px',
  gap: '4px',
};
